import React from "react";
import AllTickets from "../component/sections/ticket/AllTickets";
import AddTickets from "../component/sections/ticket/AddTickets";
import ViewTickets from "../component/sections/ticket/ViewTickets";

const ticketRoutes = [
  {
    path: "/ticket/view/:id",
    render: () => <ViewTickets />,
    exact: true,
  },
  {
    path: "/ticket/add",
    render: () => <AddTickets />,
    exact: true,
  },
  {
    path: "/tickets",
    render: () => <AllTickets />,
    exact: true,
  },
];

export default ticketRoutes;
